import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import {
    DEFAULT_FONT,
    DEFAULT_FONT_SIZE,
    DEFAULT_HEADLINE_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';

import { LEFT, CENTER, RIGHT } from 'common/entities/form/styleConfiguration/constants';
import { baseLineHeight } from 'common/styles/typography';
import { getFormContentStyles } from 'common/entities/form/styleConfiguration/selectors';

import { withFormId } from '../../FormIdContext';

import parseFontSize from '../../../utils/parseFontSize';

import QuestionView from '../question/QuestionView';

import SanitizedHTML from '../../SanitizedHTML';

const StyledContentNode = styled.p`
    font-family: ${({ themeFontFamily }) => themeFontFamily.value};
    font-size: ${({ themeFontSize }) => parseFontSize(themeFontSize)};
    color: ${({ themeColor }) => themeColor.value};
    word-wrap: break-word;
    text-align: ${({ themePosition }) => themePosition};
    padding: 0.5em 0;
    line-height: ${baseLineHeight};
    a:focus {
        outline: none;
    }
`;

const ContentNode = ({ description, visible, font, fontSize, color, position }) => (
    <QuestionView visible={visible}>
        <StyledContentNode
            visible={visible}
            themeFontFamily={font}
            themeFontSize={fontSize}
            themeColor={color}
            themePosition={position}
        >
            <SanitizedHTML innerHtml={description || ''} />
        </StyledContentNode>
    </QuestionView>
);

ContentNode.propTypes = {
    description: PropTypes.node.isRequired,
    visible: PropTypes.bool.isRequired,
    fontSize: PropTypes.number,
    font: styleShapePropTypes,
    color: styleShapePropTypes,
    position: PropTypes.oneOf([LEFT, CENTER, RIGHT]).isRequired,
};

ContentNode.defaultProps = {
    description: null,
    fontSize: DEFAULT_FONT_SIZE,
    font: getDefaultStyle(DEFAULT_FONT),
    color: getDefaultStyle(DEFAULT_HEADLINE_COLOR),
    position: CENTER,
};

const mapStateToProps = (state, props) => {
    const { formId } = props;
    const { font, fontSize, color, position } = getFormContentStyles(state, formId);

    return {
        font,
        fontSize,
        color,
        position,
    };
};

export default withFormId(connect(mapStateToProps, {})(ContentNode));
